module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","msg":{"error":"An error has occured."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/locales/fr.json
// module id = 1366
// module chunks = 0